import $ from "jquery";
import messageResource from "../messageResource";
import TableTooltip from "./TableTooltip";
import CitiesSearchController from "./CitiesSearchController";
import SpinnerController from "../SpinnerController";
import Spinner from "../spin.min";
import makeRpcCall from "../util/jquery_rpc";
import {KEY_CODE_ESC} from "../keyCodes";
import {trim, formatRawSecondsOffset} from "../atUtils";
import {calculateTooltipOffset} from "../atBrowserUtils";

export default function TimeZonesSelector() {}

TimeZonesSelector.prototype.init = function($container, initCity, onChangeCallback, emptySelectionMessage, isShowSearchResultsToTop, additionalClasses, preventDefaultTabMoving)
{

    var self = this;

    this.onChangeCallback = onChangeCallback;

    this.initialCity = initCity; // save initial value
    this.currentCity = initCity;

    this.selectorContainer = $container;
    this.selectorContainer.addClass("timeZonesSelector");

    this.selectedTZInfoContainer = $("<div class='selectedTimeZone'></div>");
    this.selectorContainer.append(this.selectedTZInfoContainer);

    this.searchField = $("<input type='text' maxlength='250' class='timeZonesSearchField'/>");
    this.selectorContainer.append(this.searchField);

    var tooltipId = "timeZoneSelectorTooltip";
    this.tooltipElement = $.find("#"+tooltipId);
    if(this.tooltipElement.length == 0)
    {
        this.tooltipElement = $("<div id='" + tooltipId + "' class='timeZoneSelectorTooltip yellowTooltip'></div>").hide();
        $("body").append(this.tooltipElement); //append to body
    } else {
        this.tooltipElement = $(this.tooltipElement[0]);
    }

    this.isNeedToShowTooltip = false;

    this.tooltip = new TableTooltip().init(tooltipId);
    this.selectedTZInfoContainer.on("mouseover", function()
                                    {
                                        if (self.isNeedToShowTooltip)
                                        {
                                            self.tooltip.show()
                                        }
                                    }
    );
    this.selectedTZInfoContainer.on("mousemove", function(event) {self.tooltip.move(calculateTooltipOffset(self.tooltip, event))});
    this.selectedTZInfoContainer.on("mouseout", function() {self.tooltip.hide()});


    this.isDisabled = false;
    // if service available init all controls otherwise show tooltip
    if (this._isServicesAvailable())
    {
        this.selectedTZInfoContainer.on("click", function()
        {
            self._showSearchField(true, true);
        });

        this.searchField.on("keydown", function(event)
        {
            if (event.keyCode == KEY_CODE_ESC)
            {
                self._onCancelAction();
                event.preventDefault();
                return false;
            }
        });
        this.searchField.on("focus", function()
        {
            if(self.rpc)
            {
                self.rpc.abort();
            }
            self._showSearchField(false, false); //show search panel
        });
        this.searchField.on("blur", function()
        {
            if (trim(self.searchField.val()) == "") // if there is no value un focus and set prev city
            {
                self._showSelectedTimeZoneCity(self.currentCity, false);
            }
        });

        this.spinnerController = new SpinnerController(true);
        this.spinnerController.setSpinner(new Spinner({length: 3, width: 2, radius: 3, lines: 8, color: '#aaaaaa', trail: 60}));

        this.citiesSearchController = new CitiesSearchController().init(
                this.searchField,
                $.proxy(this._getTimeZoneInformationForCity, this),
                function() {self.spinnerController.spinInElement(self.selectorContainer)},
                function() {self.spinnerController.stop()},
                function()
                {
                    self.spinnerController.stop();
                    self._temporaryNotAvailableServiceErrorHandler();
                },
                isShowSearchResultsToTop,
                additionalClasses,
                (preventDefaultTabMoving) ? true : false
        );

        $(document).on("mousedown", function(event)
        {
            if (self.isSearchState)
            {
                var target = event.target;
                while (target)
                {
                    if (target == self.searchField[0] ||
                        (self.citiesSearchController.isShow() && target == self.citiesSearchController.getSearchPanelElement()[0])
                    )
                    {
                        return;
                    }
                    target = target.parentElement;
                }
                if(self.citiesSearchController.isShow())
                {
                    self._onCancelAction();
                }
            }
        });
        var resizeCallback = function(){self.citiesSearchController.hide(); self._showSelectedTimeZoneCity(self.currentCity, true);};
        $(window).off("resize", resizeCallback).on("resize", resizeCallback);
    }
    else
    {
        this.isDisabled = true;
        this.selectorContainer.addClass("disabled");
        this._showTooltip(messageResource.getMessage("time_zones_selector.js.error.service_not_available"));
    }

    this.emptySelectionMessage = emptySelectionMessage ? emptySelectionMessage : messageResource.getMessage("time_zones_selector.js.empty_selection");
    // show current city
    this._showSelectedTimeZoneCity(initCity, true);

    return this;
};

TimeZonesSelector.prototype._onCancelAction = function()
{
    this.searchField.val("");
    this.citiesSearchController.hide();
    this._showSelectedTimeZoneCity(this.currentCity, true);
};

TimeZonesSelector.prototype._showSelectedTimeZoneCity = function(selectedCity, forceBlur)
{
    if (forceBlur)
    {
        this.searchField.blur();
    }

    this.selectedTZInfoContainer.empty();
    if (selectedCity)
    {
        var cityName = $("<div class='cityName'>" + selectedCity.name + "</div>");

        var offset = $("<div class='tzOffset'>" + messageResource.getMessage("time_zones_selector.js.gmt", [formatRawSecondsOffset(selectedCity.rawOffset)]) + "</div>");
        this.selectedTZInfoContainer.append(cityName).append(offset);

    }
    else
    {
        this.selectedTZInfoContainer.append("<div class='emptySelection'>" + this.emptySelectionMessage + "</div>");
    }
    this.selectedTZInfoContainer.show();

    this.isSearchState = false;
};

TimeZonesSelector.prototype._showSearchField = function(forceFocus, updateValue)
{
    this._hideErrors();

    if (updateValue)
    {
        if (this.currentCity)
        {
            this.searchField.val(this.currentCity.name);
        }
        else
        {
            this.searchField.val("");
        }
    }

    this.selectedTZInfoContainer.hide();
    if (forceFocus)
    {
        this.searchField.focus();
    }
    this.citiesSearchController.processSearchQuery();

    this.isSearchState = true;
};

TimeZonesSelector.prototype.resetToInit = function()
{
    this.currentCity = this.initialCity;
    this._hideErrors();
    this.cancelSearch();
};

TimeZonesSelector.prototype.cancelSearch = function()
{
    if (!this.isDisabled)
    {
        this._onCancelAction();
        if (this.rpc)
        {
            this.rpc.abort();
        }
    }
};

TimeZonesSelector.prototype._getTimeZoneInformationForCity = function(currentCity)
{
    this.spinnerController.spinInElement(this.selectorContainer);

    var lat = currentCity.geometry.location.lat();
    var lng = currentCity.geometry.location.lng();
    var self = this;
    this.rpc = makeRpcCall(
            "TimeZonesService.getTimeZoneInfo",
            [lat, lng],
            function(response)
            {
                var city = {
                    name: currentCity.name,
                    placeId: currentCity.place_id,
                    timeZoneId: response.timeZoneId,
                    rawOffset: response.rawOffset,
                    currentTime: response.currentTime
                };

                self.onChangeCallback(city);
                self._showSelectedTimeZoneCity(city, true);
                self.currentCity = city;
                self.spinnerController.stop();
            },
            function(jqXHR, textStatus, errorThrown)
            {
                self.spinnerController.stop();
                if (textStatus != 'abort')
                {
                    self._temporaryNotAvailableServiceErrorHandler();
                    if (errorThrown.exception == "com.actimind.common.services.TimeZoneNotReceivedException")
                    {
                        console.error(errorThrown.msg);//for support
                        return true;
                    }
                }
            }
    );
};

TimeZonesSelector.prototype._isServicesAvailable = function()
{
    return (window.google && window.google.maps && window.google.maps.places) != undefined;
};

TimeZonesSelector.prototype._showTooltip = function(message)
{
    this.tooltipElement.empty().text(message);
    this.isNeedToShowTooltip = true;
};

TimeZonesSelector.prototype._temporaryNotAvailableServiceErrorHandler = function()
{
    this._showSelectedTimeZoneCity(this.currentCity, true);
    this.selectorContainer.toggleClass("error", true);
    this._showTooltip(messageResource.getMessage("time_zones_selector.js.error.service_temporary_not_available"));
};

TimeZonesSelector.prototype._hideErrors = function()
{
    this.isNeedToShowTooltip = false;
    this.selectorContainer.toggleClass("error", false);
};



// WEBPACK FOOTER //
// ./web/js/controls/TimeZonesSelector.js